<div class="status-bar" role="status" aria-label="Beheerconsole status">
  <div class="status-bar-left">
    <span class="status-env" [attr.data-env]="envName" [title]="envTitle">
      <span class="status-env-dot" aria-hidden="true"></span>
      {{ envName }}
    </span>

    <span class="status-sep" aria-hidden="true"></span>

    <span class="status-item" [title]="'API-host: ' + apiHost">
      <span class="status-label">host</span>
      <span class="status-value">{{ apiHost }}</span>
    </span>

    <ng-container *ngFor="let item of placeholders">
      <span class="status-sep" aria-hidden="true"></span>
      <span
        class="status-item"
        [class.is-placeholder]="item.placeholder"
        [title]="item.title">
        <span class="status-label">{{ item.label }}</span>
        <span class="status-value">{{ item.value }}</span>
      </span>
    </ng-container>
  </div>

  <div class="status-bar-right">
    <span class="status-item status-klok" [class.is-anders]="klok.anders" [title]="klok.titel">
      <span class="status-value">{{ klok.tijd }}</span>
      <span class="status-label">{{ klok.zone }}</span>
    </span>
    <span class="status-sep" aria-hidden="true"></span>
    <span class="status-item" *ngIf="role" [title]="'Rol: ' + role">
      <span class="status-label">rol</span>
      <span class="status-value">{{ role }}</span>
    </span>
    <span class="status-sep" *ngIf="role" aria-hidden="true"></span>
    <span class="status-version-group" [title]="'siq_adminapp ' + versionLabel">
      <button type="button"
              class="status-version"
              title="Release notes"
              (click)="onOpenVersionNotes()">
        {{ versionDisplay }}
      </button>
      <span class="status-version-paren" aria-hidden="true">(</span>
      <button type="button"
              class="status-build-ref"
              title="Deploy history — last 10 merges / PR#"
              (click)="onOpenBuildHistory()">
        {{ buildRef }}
      </button>
      <span class="status-version-paren" aria-hidden="true">)</span>
    </span>
  </div>
</div>
